import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SolutionsService {
  private cache$: Observable<any[]>;

  constructor(private http: HttpClient) { }

  public get Solutions() {
    if(!this.cache$) {
      this.cache$ = this.requestSolutions().pipe(shareReplay(1))
    }
    return this.cache$;
  }

  private requestSolutions(){
    return  this.http.get('assets/solutions.json').pipe(map((items: any[]) => {
      return [...items].sort((a, b) => a.order - b.order);
    }));
  }
}
